<template>
  <div id="app">
    <header v-on:click="onStartClick">
      <img width="24" height="24" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAQAAABKfvVzAAAAAmJLR0QA/4ePzL8AAAAJcEhZcwAADsQAAA7EAZUrDhsAAAAHdElNRQfkAhoOIDXNzNokAAABTUlEQVQ4y92Tvy9DURzFz9MJgyZSkSYaEdLB0PgDJAYxEDoKg1GYtNjF6g8wSSQmI4Nd0q1dpCLa6NayECKWarUfw7v98W4vdmf63nfOue+e7/deTwEwpVXNKa5hNfWoB13p0nuSG0xwQQMbnxwTlSQi5Mh05Bt88BNeWWKEW4CWfI8mv6FBxS98+VoXVSBNgjADxNnixnZKYpx3s6qxjxfI5bFN1TacmrrOvKMVEQoBA2N8mTrtlOetI7FjqhIhhyFnZ+hTwnBHXsMxnKq1zug/gIzVBmcsNg17qJ5bk3XIQ5QMu2Ib8kQchl3DvtEfNBSd8gXqhj+QgoYaqeC88dinZtgyQ7YB4J4U0wwSZoY9iu3vdWb9PXxU/nhAddZbPzVRSbZfRS+eWe6eQ9aPSoyTdrzuXGeMdlJ5VkdiSmpRk4oKvehO1zr3yt2Kb1ejLiMVe2t3AAAAAElFTkSuQmCC" />
      <span>Daniels TT Kalender</span>
      <span class="right"></span>
    </header>
    <main>
      <router-view></router-view>
    </main>
  </div>
</template>

<script>
import EventBus from './bus'

export default {
  name: 'app',
  methods: {
    onStartClick: function (event) {
      EventBus.$emit('startClick')
    }
  }
}
</script>

<style>
body {
  margin: 0;
}

#app {
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

main {
  text-align: center;
  margin-top: 5px;
  padding: 0 10px;
}

header {
  margin: 0;
  height: 44px;
  padding: 0 16px 0 14px;
  background-color: #35495E;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
}

header img {
  align-items: flex-start;
}

header .right {
  opacity: 0;
}

header span {
  font-size: 20px;
  line-height: 1;
  letter-spacing: .02em;
  font-weight: 400;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/App.vue